<template>
  <div class="vacancy-card-action" :class="selectors">
    <div class="vacancy-card-action__col _places">
      <div class="vacancy-card-action__label"><span>{{ $tVacancy('Places') }}</span></div>
      <div class="vacancy-card-action__places">{{ vacancy[1].quantity }}</div>
    </div>
    <div class="vacancy-card-action__col _timer">
      <div class="vacancy-card-action__label"><span>{{ $tVacancy('Still relevant') }}</span></div>
      <TimerSmall :endTime="vacancy[1].relevant"
                  class="vacancy-card-action__timer"
      />
    </div>
    <div class="vacancy-card-action__col _responded">
      <div v-if="small"
           style="justify-content: center"
           class="vacancy-card-action__label">
        <span>{{ $tVacancy('Views') }} <b>{{ vacancy.views }}</b></span>
      </div>
      <div v-else
           class="vacancy-card-action__label"><span>{{ $tVacancy('Responded') }} <b>{{
          vacancy.resume_count
        }}</b></span></div>

      <router-link-modified v-if="small"
                            type="button"
                            class="vacancy-card-action__btn  base-btn--green base-btn _small  "
                            :to="{ name: 'vacancy', params: { vacancyId: vacancy.slug } }">
        <span class="base-btn__text  d-xs-none">{{ $tVacancy('More details') }}</span>
        <BaseSvg name="ico-arrow-light"
                 style="width: .6rem;height: .9rem; margin: 0"
                 class="d-none d-xs-inline-flex"/>
      </router-link-modified>

      <template v-else>
        <router-link-modified type="button"
                              class="vacancy-card-action__btn  base-btn--green base-btn d-xs-none"
                              :to="{ name: 'vacancy', params: { vacancyId: vacancy.slug } }">
          <span class="base-btn__text">{{ $tVacancy('More details') }}</span>
        </router-link-modified>
        <router-link-modified type="button"
                              class="vacancy-card-action__btn  base-btn--green base-btn d-none d-xs-inline-flex"
                              :to="{ name: 'vacancy', params: { vacancyId: vacancy.slug } }">
          <BaseSvg name="ico-arrow-light" style="width: .6rem;height: .9rem"/>
        </router-link-modified>
      </template>

    </div>

  </div>
</template>

<script>
  import TimerSmall from './TimerSmall';

  export default {
    name: 'VacancyCardAction',
    components: {TimerSmall},
    props: {
      vacancy: {
        type: Object,
        required: true
      },
      small: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selectors() {
        return {
          '_attention': this.vacancy[1].quantity < 5,
          '_disabled': this.vacancy[1].quantity === 0
        }
      }
    }
  };
</script>

<style>

</style>
